import { ChatsPanel, pvtChat } from '../Chat/UI/Chat-New';
import { singleChatPanel, messageSent, messageReceivedPvt } from '../Chat/UI/SingleChatComponent-UI';
import { chatFetcher } from '../MVC/chatFetcher';
import { formatMessageTime } from '../engine/helpers/chatHelper';
import '../../styles/components/spacesMessages.scss';

const DEFAULT_AVATAR = '/textures/defaultAvatar.png';

export default class SpacesMessages {
  constructor({ socket, friends, config }) {
    this.socket = socket;
    this.friends = friends;
    this.config = config || {};
    this.anchor = document.getElementById('spaces-online-friends');
    this.unread = new Map();
    this.threads = new Map();
    this.activeThreadId = null;
    this.listOpen = false;

    if (!this.anchor || !this.socket || window.isGuest) {
      return;
    }

    this.mountButton();
    this.mountList();
    this.mountOfflineDialog();
    this.bindOutsideClick();
    if (this.friends) {
      this.friends.onOpen = () => this.closeAll();
      this.friends.onChat = (user) => this.openThread(user);
    }
    this.socket.onAnyMessage((payload) => this.onSocketMessage(payload));
    this.loadConversations();
    window.baglessOpenCallOutcome = (userId, name, outcome) => {
      this.openWithOutcome({
        id: userId,
        username: name || 'Friend',
      }, outcome);
    };
  }

  mountButton() {
    let bar = this.anchor.parentElement;
    if (!bar || !bar.classList.contains('spaces-presence')) {
      bar = document.createElement('div');
      bar.className = 'spaces-presence';
      this.anchor.parentNode.insertBefore(bar, this.anchor);
      bar.appendChild(this.anchor);
    }

    const create = document.getElementById('create-space');
    if (create && create.parentElement !== bar) {
      bar.insertBefore(create, bar.firstChild);
    }

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'spaces-messages-button';
    this.button.setAttribute('aria-label', 'Messages');
    this.button.innerHTML = `
      <span class="material-icons spaces-messages-button__icon" aria-hidden="true">chat</span>
      <span class="spaces-messages-button__badge">0</span>
    `;
    const tools = document.createElement('div');
    tools.className = 'spaces-presence__tools';
    bar.insertBefore(tools, this.anchor);
    tools.append(this.button, this.anchor);
    this.badge = this.button.querySelector('.spaces-messages-button__badge');

    this.button.addEventListener('click', () => {
      if (this.activeThreadId) {
        this.closeThread();
        this.openList();
        return;
      }
      if (this.listOpen) {
        this.closeList();
      } else {
        this.openList();
      }
    });
  }

  mountList() {
    this.list = $(ChatsPanel()).filter('.chat-panel');
    this.list.find('.section-title[data-lang="current-room"]').hide();
    this.list.find('.icon-close').on('click', (event) => {
      event.stopPropagation();
      this.closeList();
    });
    this.list.on('click', '.chat-card', (event) => {
      const cardEl = event.target.closest && event.target.closest('.chat-card');
      if (!cardEl) {
        return;
      }
      event.stopPropagation();
      const id = String(cardEl.id || '').replace('chatUI-', '');
      const card = this.conversations.find((item) => String(item.id) === id);
      if (card) {
        this.openThread(card);
      }
    });
    this.conversations = [];
    $(document.body).append(this.list);
    this.applyLanguage();
  }

  mountOfflineDialog() {
    this.offlineDialog = $(`
      <div class="spaces-offline-message" hidden>
        <div class="spaces-offline-message__card">
          <p data-lang="send-offline-message">User is offline</p>
          <p class="spaces-offline-message__note">Want to notify user anyway?</p>
          <div class="spaces-offline-message__actions">
            <button type="button" class="spaces-offline-message__send" data-lang="send-offline-message-ok">Send</button>
            <button type="button" class="spaces-offline-message__cancel" data-lang="cancel-text">Cancel</button>
          </div>
        </div>
      </div>
    `);
    this.offlineDialog.find('.spaces-offline-message__cancel').on('click', () => {
      this.offlineDialog.attr('hidden', true);
      this.pendingOffline = null;
    });
    this.offlineDialog.find('.spaces-offline-message__send').on('click', () => {
      const pending = this.pendingOffline;
      this.offlineDialog.attr('hidden', true);
      this.pendingOffline = null;
      if (pending) {
        this.emitMessage(pending.thread, pending.text, true);
      }
    });
    $(document.body).append(this.offlineDialog);
  }

  loadConversations() {
    chatFetcher.getLatestChats((response) => {
      const rows = (response && response.data && response.data.data) || [];
      this.conversations = rows.map((row) => {
        const user = row.user || {};
        const last = row.lastMessage || {};
        return {
          id: user.id,
          username: user.username || 'Friend',
          avatar: user.avatarImageUrl || DEFAULT_AVATAR,
          lastMessage: last.message || '',
          lastTime: safeTime(last.timestamp),
          unread: Number(row.unreadCount) || 0,
        };
      }).filter((user) => user.id);
      this.conversations.forEach((user) => {
        this.setUnread(user.id, Math.max(this.unreadCount(user.id), user.unread));
      });
      this.renderConversations();
      this.renderBadge();
    });
  }

  renderConversations() {
    this.list.find('.chat-card').remove();
    let cursor = this.list.find('.section-title[data-lang="latest-chats"]');
    this.list.find('.chat-count').text(this.conversations.length);
    this.conversations.forEach((user) => {
      const card = $(pvtChat({
        id: user.id,
        img: escapeAttr(user.avatar),
        title: escapeHtml(user.username),
        lastMessage: escapeHtml(user.lastMessage || ''),
        timestamp: user.lastTime || '',
      }));
      this.paintCardBadge(card, this.unreadCount(user.id));
      attachAvatarFallback(card.find('.avatar img').get(0));
      cursor.after(card);
      cursor = card;
    });
  }

  openList() {
    if (this.friends && typeof this.friends.close === 'function') {
      this.friends.close();
    }
    this.listOpen = true;
    this.list.show();
    document.body.classList.add('spaces-sheet-open');
    this.button.classList.add('is-selected');
    this.renderBadge();
    this.applyLanguage();
  }

  closeList() {
    this.listOpen = false;
    this.list.hide();
    if (!this.activeThreadId) {
      this.button.classList.remove('is-selected');
      document.body.classList.remove('spaces-sheet-open');
    }
  }

  openThread(user) {
    if (this.friends && typeof this.friends.close === 'function') {
      this.friends.close();
    }
    this.closeList();
    this.threads.forEach((thread) => thread.el.hide());
    let thread = this.threads.get(String(user.id));
    if (!thread) {
      thread = this.createThread(user);
      this.threads.set(String(user.id), thread);
    }
    this.activeThreadId = String(user.id);
    thread.el.show();
    document.body.classList.add('spaces-sheet-open');
    this.button.classList.add('is-selected');
    this.setUnread(user.id, 0);
    this.paintCardBadge(this.list.find(`#chatUI-${user.id}`), 0);
    this.renderBadge();
    this.loadHistory(thread);
  }

  openWithOutcome(user, outcome) {
    this.openThread(user);
    const thread = this.threads.get(String(user.id));
    if (thread && outcome) {
      thread.outcome = outcome;
    }
  }

  createThread(user) {
    const el = $(singleChatPanel({ id: `spaces-chat-${user.id}`, name: escapeHtml(user.username) }));
    el.find('.messages-container').empty();
    el.find('.action-button--icon-three-dots').hide();
    el.hide();
    el.find('.back-button').on('click', () => {
      this.closeThread();
      this.openList();
    });
    el.find('.header-actions .action-button[aria-label="Chat options"]').on('click', () => {
      this.closeThread();
    });
    el.find('.icon-emoji').on('click', () => {
      const menu = el.find('.message-input__emoji-menu');
      menu.toggle();
    });
    el.find('.message-input__emoji-menu__item').on('click', (event) => {
      const input = el.find('.input-placeholder');
      input.val(`${input.val()}${$(event.currentTarget).text()}`);
      el.find('.message-input__emoji-menu').hide();
      input.trigger('focus');
    });
    el.find('.message-input').on('submit', (event) => {
      event.preventDefault();
      this.send(el, user);
    });
    el.find('.icon-send').on('click', () => this.send(el, user));
    $(document.body).append(el);
    return { el, user, loaded: false };
  }

  closeAll() {
    this.closeThread();
    this.closeList();
  }

  bindOutsideClick() {
    document.addEventListener('click', (event) => {
      if (!this.listOpen && !this.activeThreadId) {
        return;
      }
      if (isInside(this.button, event.target) || isInside(this.list, event.target) || isInside(this.offlineDialog, event.target)) {
        return;
      }
      for (const thread of this.threads.values()) {
        if (isInside(thread.el, event.target)) {
          return;
        }
      }
      this.closeAll();
    });
  }

  closeThread() {
    if (!this.activeThreadId) {
      return;
    }
    const thread = this.threads.get(this.activeThreadId);
    if (thread) {
      thread.el.hide();
    }
    this.activeThreadId = null;
    this.button.classList.remove('is-selected');
    if (!this.listOpen) {
      document.body.classList.remove('spaces-sheet-open');
    }
  }

  send(el, user) {
    const input = el.find('.input-placeholder');
    const text = input.val().trim();
    if (!text) {
      return;
    }
    const thread = this.threads.get(String(user.id));
    if (this.friends && !this.friends.isOnline(user.id)) {
      this.pendingOffline = { thread, text };
      this.offlineDialog.removeAttr('hidden');
      this.applyLanguage();
      return;
    }
    input.val('');
    this.emitMessage(thread, text, false);
  }

  emitMessage(thread, text, offline) {
    if (!thread) {
      return;
    }
    const input = thread.el.find('.input-placeholder');
    input.val('');
    const payload = {
      eventName: offline ? 'chatOfflineMessage' : 'chatMessage',
      text,
      senderId: this.config.userId,
      senderName: this.config.userName,
      senderAvatarUrl: this.config.userAvatarUrl,
      receiverId: thread.user.id,
      receiverName: thread.user.username,
      receiverType: 'user',
      sceneId: 0,
      time: new Date().toISOString(),
    };
    this.socket.send(payload);
    this.appendMessage(thread, text, 'sent');
    this.preview(thread.user.id, text, payload.time);
  }

  loadHistory(thread) {
    thread.el.find('.messages-container').empty();
    chatFetcher.getPrivateMessages(thread.user.id, 0, 50, (response) => {
      const messages = ((response && response.data) ? response.data : []).slice().reverse();
      messages.forEach((message) => {
        const type = Number(message.sender_id) === Number(this.config.userId) ? 'sent' : 'received';
        this.appendMessage(thread, message.message, type, message.timestamp);
      });
      if (messages.length) {
        const last = messages[messages.length - 1];
        this.preview(thread.user.id, last.message, last.timestamp);
      }
      if (thread.outcome) {
        this.appendOutcome(thread, thread.outcome);
        thread.outcome = null;
      }
    });
  }

  appendOutcome(thread, outcome) {
    const labels = {
      missed: 'Missed video call',
      declined: 'Call declined',
      cancelled: 'Call cancelled',
      answered: 'Call answered',
    };
    const label = labels[outcome] || 'Call ended';
    const note = document.createElement('div');
    note.className = 'spaces-call-outcome';
    const text = document.createElement('p');
    text.textContent = label;
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Call back';
    button.addEventListener('click', () => {
      if (typeof window.baglessStartVideoCall === 'function') {
        window.baglessStartVideoCall(thread.user.id, thread.user.username);
      }
    });
    note.append(text, button);
    thread.el.find('.messages-container').append(note);
  }

  onSocketMessage(payload) {
    if (!payload || payload.receiverType !== 'user') {
      return;
    }
    if (payload.eventName !== 'chatMessage' && payload.eventName !== 'chatOfflineMessage') {
      return;
    }
    if (String(payload.senderId) === String(this.config.userId)) {
      return;
    }
    const senderId = String(payload.senderId);
    const thread = this.threads.get(senderId);
    if (this.activeThreadId === senderId && thread) {
      this.appendMessage(thread, payload.text, 'received', payload.time);
    } else {
      this.setUnread(senderId, this.unreadCount(senderId) + 1);
      this.renderBadge();
    }
    this.ensureConversation(payload);
    this.preview(senderId, payload.text, payload.time);
    this.paintCardBadge(this.list.find(`#chatUI-${senderId}`), this.unreadCount(senderId));
  }

  ensureConversation(payload) {
    const id = String(payload.senderId);
    if (this.conversations.some((user) => String(user.id) === id)) {
      return;
    }
    this.conversations.unshift({
      id: payload.senderId,
      username: payload.senderName || 'Friend',
      avatar: payload.senderAvatarUrl || DEFAULT_AVATAR,
    });
    this.renderConversations();
  }

  preview(userId, text, time) {
    const formatted = safeTime(time);
    const person = this.conversations.find((user) => String(user.id) === String(userId));
    if (person) {
      person.lastMessage = text || '';
      person.lastTime = formatted;
    }
    const card = this.list.find(`#chatUI-${userId}`);
    if (!card.length) {
      return;
    }
    card.find('.chat-message').text(text || '');
    card.find('.chat-time').text(formatted);
  }

  appendMessage(thread, text, type, time) {
    const timestamp = safeTime(time);
    const safe = escapeHtml(text);
    const html = type === 'sent'
      ? messageSent({ text: safe, timestamp })
      : messageReceivedPvt({ text: safe, timestamp });
    const box = thread.el.find('.messages-container');
    box.append(html);
    const node = box.get(0);
    if (node) {
      node.scrollTop = node.scrollHeight;
    }
  }

  unreadCount(userId) {
    return this.unread.get(String(userId)) || 0;
  }

  setUnread(userId, count) {
    const key = String(userId);
    const next = Math.max(0, Number(count) || 0);
    if (next > 0) {
      this.unread.set(key, next);
    } else {
      this.unread.delete(key);
    }
  }

  totalUnread() {
    let total = 0;
    this.unread.forEach((count) => {
      total += count;
    });
    return total;
  }

  paintCardBadge(card, count) {
    if (!card || !card.length) {
      return;
    }
    const badge = card.find('.notification-badge');
    card.toggleClass('has-notification', count > 0);
    if (count > 0) {
      badge.text(count > 99 ? '99+' : String(count)).css('display', 'flex');
    } else {
      badge.hide();
    }
  }

  renderBadge() {
    const count = this.totalUnread();
    this.badge.textContent = count > 99 ? '99+' : String(count);
    this.button.classList.toggle('has-unread', count > 0);
  }

  applyLanguage() {
    if (window.multiLanguagesController && typeof window.multiLanguagesController.renderLanguage === 'function') {
      window.multiLanguagesController.renderLanguage();
    }
  }
}

function isInside(node, target) {
  if (!node || !target) {
    return false;
  }
  const elements = node.jquery ? node.get() : [node];
  return elements.some((element) => element && element.nodeType === 1 && element.contains(target));
}

function attachAvatarFallback(img) {
  if (!img) {
    return;
  }
  img.addEventListener('error', function onAvatarError() {
    img.removeEventListener('error', onAvatarError);
    if (img.getAttribute('src') === DEFAULT_AVATAR) {
      return;
    }
    img.src = DEFAULT_AVATAR;
  });
}

function safeTime(time) {
  if (!time) {
    return '';
  }
  const raw = String(time).trim();
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return formatMessageTime(date.toISOString());
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(value) {
  return escapeHtml(value);
}
